import { useEffect, useRef, useState } from "react";
import { Button } from "@oc-labs/wt-storybook";
import EventCard from "./components/EventCard";
import UpsertEventModal from "../../../components/modals/upsert-event-v2/UpsertEventModal";
import useEvent from "../../../hooks/useEvent";
import useModal from "../../../hooks/useModal";
import useCompany from "../../../hooks/useCompany";

function Events() {
	const { open } = useModal("upsert-event");
	const { activeCompany } = useCompany();
	const { events, error, getAllEvents } = useEvent();

	const [showSearch, setShowSearch] = useState(false);
	const [query, setQuery] = useState("");
	const searchRef = useRef(null);

	useEffect(() => {
		if (activeCompany?.id) {
			getAllEvents();
		}
	}, [activeCompany?.id]);

	const filteredEvents = events.filter((event) => {
		return (event?.name || "").toLowerCase().includes(query.toLowerCase())
	});

	const handleSearchVisible = () => {
			setShowSearch((prev) => {
					const next = !prev;
					if (next && searchRef.current) searchRef.current.focus();
					return next;
			});
	};

	return (<div className="p-6 grid grid-cols-1 xl:grid-cols-12 gap-8">
		<UpsertEventModal reload={getAllEvents} />

		<div className="col-span-1 xl:col-span-12">
			<div className="flex justify-between items-center mb-4">
                            <h1 className="2xl:text-xl text-base font-medium">All events</h1>				<div className="flex space-x-2">
					<Button
						type="secondary"
						size="small"
						onClick={() => open()}
						icon={
							<img
								src="/icons/add.svg"
								alt=""
								width={16}
								height={16}
								className="block w-4 h-4 shrink-0"
							/>
						}
						className="whitespace-nowrap"
						disabled={!activeCompany?.id}
					>
						New event
					</Button>

						<div className="relative">
							<input
								type="text"
								ref={searchRef}
								value={query}
								onChange={(e) => setQuery(e.target.value)}
								placeholder="Search"
								onFocus={() => setShowSearch(true)}
								onBlur={() => setShowSearch(false)}
								className={`pl-10 pr-4 py-[6px] h-[32px] bg-gray-100 rounded-full text-sm ${showSearch ? "w-72" : "w-32"
									} outline-none transition-all duration-300`}
							/>
								<img
									src="/icons/search.svg"
									alt="Search"
									className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer"
									onClick={handleSearchVisible}
								/>
						</div>
				</div>
			</div>
		</div>

		<div className="col-span-1 xl:col-span-12 grid xl:grid-cols-2 grid-cols-1 gap-6">
			{filteredEvents.length > 0 ? filteredEvents.map((evt) => {
				return <EventCard key={evt?.id} event={evt} />
			}) : <div className="py-4 px-6 text-gray-500 italic text-sm">
				No events found.
			</div>}
		</div>
	</div>);
}

export default Events;
